import { Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';

import MitIdRedirect from '@swf/components/MitIdRedirect/MitIdRedirect';

import Prompt from '../../Prompt/Prompt';
import { promptTitleCapitalize } from '../shared.scss';

import {
  TXTWCL_Failed_MitID_verification,
  TXTWCL_SorryX_you_must_verify_your_id_ELL,
  TXTWCL_Try_again
} from './DKMitIdAuthError.messages.json';

const DKMitIdAuthError: React.FC = () => {
  const [showMitIdRedirect, setShowMitIdRedirect] = useState(false);
  const handleTryAgain = () => setShowMitIdRedirect(true);
  return (
    <>
      <Prompt
        classes={{ title: promptTitleCapitalize }}
        variant="default"
        title={{ translation: TXTWCL_Failed_MitID_verification }}
        noCloseButton
        primaryButton={{ translation: TXTWCL_Try_again }}
        onPrimaryButtonClick={handleTryAgain}
      >
        <Translation tagName="p" {...TXTWCL_SorryX_you_must_verify_your_id_ELL} />
      </Prompt>
      {showMitIdRedirect && <MitIdRedirect />}
    </>
  );
};

export default DKMitIdAuthError;
